/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Chip } from "@mui/material";
import { ScoringRule } from "./types";

const getColumns = ({
  onEdit,
}: {
  onEdit: (row: ScoringRule) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "ruleType",
    headerName: "Rule Type",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "description",
    headerName: "Description",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "score",
    headerName: "Score",
    width: 100,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "enabled",
    headerName: "Enabled",
    width: 120,
    align: "center",
    headerAlign: "center",
    valueFormatter: (value) => (value ? "Enabled" : "Disabled"),
    renderCell: (params) => (
      <Chip
        label={params.value ? "Enabled" : "Disabled"}
        color={params.value ? "success" : "default"}
        size="small"
      />
    ),
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 120,
    align: "right",
    getActions: ({ row }: { row: ScoringRule }) => [
      <Button
        key="edit"
        onClick={(e: any) => {
          e.stopPropagation();
          onEdit(row);
        }}
      >
        <EditIcon fontSize="small" />
      </Button>,
    ],
  },
];

export default getColumns;
